import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import CategoryHero from '../components/category/CategoryHero';
import CategoryProducts from '../components/category/CategoryProducts';
import CategoryFeatures from '../components/category/CategoryFeatures';
import CategoryCTA from '../components/category/CategoryCTA';
import { fetchCategories, fetchProductsByCategory } from '../services/api';

const CategoryPage = () => {
  const { categorySlug } = useParams();
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const loadCategoryData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Fetch all categories to find the one matching the slug
        const categories = await fetchCategories();
        
        // Handle Strapi v4 data structure (attributes nested)
        const foundCategory = categories.find(cat => {
          const slug = cat.attributes?.slug || cat.slug;
          return slug === categorySlug;
        });
        
        if (!foundCategory) {
          console.warn(`Category not found for slug: ${categorySlug}`);
          setNotFound(true);
          setLoading(false);
          return;
        }
        
        // Normalize category data structure
        const normalizedCategory = {
          id: foundCategory.id,
          Name: foundCategory.attributes?.Name || foundCategory.Name,
          slug: foundCategory.attributes?.slug || foundCategory.slug,
          description: foundCategory.attributes?.description || foundCategory.description,
          icon: foundCategory.attributes?.icon || foundCategory.icon,
          BackgroundImage: foundCategory.attributes?.BackgroundImage || foundCategory.BackgroundImage,
          ...foundCategory.attributes
        };
        
        setCategory(normalizedCategory);
        
        // Fetch products for this category
        const categoryProducts = await fetchProductsByCategory(foundCategory.id);
        setProducts(categoryProducts);
        
      } catch (err) {
        console.error('Error loading category data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (categorySlug) {
      loadCategoryData();
    }
  }, [categorySlug]);

  // Redirect to products page if category not found
  if (notFound) {
    return <Navigate to="/products" replace />;
  }

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-catalina-blue mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Loading category...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <CategoryHero category={category} />
      <CategoryProducts 
        products={products} 
        loading={loading} 
        error={error}
        categoryName={category?.Name}
      />
      <CategoryFeatures categoryName={category?.Name} />
      <CategoryCTA categoryName={category?.Name} />
    </div>
  );
};

export default CategoryPage;